<div class="du-mail-popup-header-bg d-flex">
        <h2 class="header">Privacy Policy & User Consent for Email Integration</h2>
        <mat-icon class="close-icon align-items-right" (click)="closePopup()">close</mat-icon>
</div>
<div class="align-items-center container">
    
    <div><strong>Effective Date:</strong> <span style="color:red"> {{currentDate}}</span></div>
    
    <div>SCRAII ("we," "us," or "our") is committed to protecting your privacy. Before proceeding with email integration, please review the key terms of our <strong>Privacy Policy</strong> regarding how we collect, use, and protect your email data.</div>
    
    <h2>Summary of Key Terms</h2>
    <div class="terms">
        <div>By enabling email integration, you consent to SCRAII:</div>
        <ul>
            <li>✅ Accessing your email address, email content, headers, and metadata to provide core functionality.</li>
            <li>✅ Storing authentication tokens securely (we do not store your email password).</li>
            <li>✅ Using collected data to improve services, enhance security, and communicate essential updates.</li>
            <li>✅ Retaining your email data as long as your account remains active or as legally required.</li>
            <li>✅ Allowing data sharing only with trusted service providers, in compliance with legal obligations.</li>
        </ul>
    </div>
        <div style="margin-top: 10px;">For full details, please read our <strong><a class="privacy" (click)="openPrivacyPolicy()">Privacy Policy</a></strong>.</div>
    
    <div>By clicking <strong>"Agree"</strong>, you acknowledge that you have read, understood, and consent to these terms.</div>
    
        <div class="buttons d-flex justify-content-end gap-2">
            <button class="submit" mat-flat-button color="primary" (click)="openMailOutlook()">Agree</button>
            <button class="cancel" mat-flat-button color="secondary" (click)="closePopup()">Cancel</button>
    </div>
</div>